var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExitToApp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "exit_to_app_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "exit_to_app_svg__ds",
    x1: -1225.86,
    y1: 9826,
    x2: -1040.09,
    y2: 9826,
    gradientTransform: "translate(1267.98 10041.4) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m168.51,280.17c-2.38,2.38-5.55,3.7-8.92,3.7s-6.54-1.31-8.92-3.7c-4.92-4.92-4.92-12.93,0-17.85l34.16-34.16H54.74c-6.96,0-12.62-5.66-12.62-12.62s5.66-12.62,12.62-12.62h130.03l-34.45-34.46c-2.38-2.38-3.7-5.55-3.7-8.92s1.31-6.54,3.7-8.92c2.38-2.38,5.55-3.7,8.92-3.7s6.54,1.31,8.92,3.7l56.02,56.02c2.38,2.38,3.7,5.55,3.7,8.92s-1.31,6.54-3.7,8.92l-55.67,55.67Z",
    style: {
      fill: "url(#exit_to_app_svg__ds)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.73,69.95c-2.32-2.32-5.52-3.64-8.8-3.64h-107.94v.4h-106v-.4H54.06c-3.27,0-6.48,1.33-8.8,3.64s-3.64,5.52-3.64,8.8v83.25h24.88v-70.41h296.99v243.21H66.5v-66.81h-24.88v79.65c0,3.28,1.33,6.48,3.64,8.8s5.52,3.64,8.8,3.64h107.94v-.4h106v.4h107.94c3.27,0,6.48-1.33,8.8-3.64s3.64-5.52,3.64-8.8V78.75c0-3.28-1.33-6.48-3.64-8.8Z",
    style: {
      fill: "#f7f7f7"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitToApp);
export default __webpack_public_path__ + "static/media/exit_to_app.b9ae7e90622bf94aaf6d5a8decf5e9ea.svg";
export { ForwardRef as ReactComponent };